<template>
  <div id="system-publish-publisher-policy">
    <div class="mar-b-40"
         v-for="item in dataSource"
         :key="item.id||item.name">
      <div class="ipub-h2 line-h-40 mar-b-20 relative">
        {{item.name}}
        <div class="right-option ipub-p1 line-h-40">
          <ipub-button type="primary"
                       icon="iconAdd"
                       @click="add">
            Add New Policy
          </ipub-button>
        </div>
      </div>
      <ipub-tree @edit="edit"
                 @delete="del"
                 @add="add"
                 @drag="setSort"
                 :deep="2"
                 :tree="item.children" />
    </div>
    <Add ref="publisher-policy-add"
         :tree="dataSource"
         :isVisable="isVisable"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
